import { Theme } from '@mui/material/styles';
import { TypographyOptions } from '@mui/material/styles/createTypography';
import environment from 'environment';

const Typography = (theme: Theme, borderRadius: number, fontFamily: string): TypographyOptions => ({
    fontFamily,
    h1: {
        fontSize: '32px',
        fontWeight: 500,
        fontFamily: `${environment.TITLE_FONT_FAMILY}, sans-serif`,
        lineHeight: '100%'
    },
    h2: {
        fontSize: '32px',
        fontWeight: 500,
        lineHeight: '140%'
    },
    h3: {
        fontSize: '22px',
        fontWeight: 600,
        lineHeight: '130%'
    },
    h4: {
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: '130%'
    },
    h5: {
        fontSize: '16px',
        fontWeight: 500,
        fontFamily: `${environment.TITLE_FONT_FAMILY}, sans-serif`,
        lineHeight: '100%'
    },
    h6: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '100%'
    },
    subtitle1: {
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '100%'
    },
    subtitle2: {
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '130%'
    },
    caption: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '130%'
    },
    body1: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '130%'
    },
    body2: {
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '130%'
    },
    button: {
        textTransform: 'capitalize'
    },
    customInput: {
        marginTop: 1,
        marginBottom: 1,
        '& > label': {
            top: 23,
            left: 0,
            color: theme.palette.grey[500],
            '&[data-shrink="false"]': {
                top: 5
            }
        },
        '& > div > input': {
            padding: '30.5px 14px 11.5px !important'
        },
        '& legend': {
            display: 'none'
        },
        '& fieldset': {
            top: 0
        }
    },
    mainContent: {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark[800] : theme.palette.grey[100],
        width: '100%',
        minHeight: 'calc(100vh - 88px)',
        flexGrow: 1,
        padding: '20px',
        marginTop: '88px',
        marginRight: '20px',
        borderRadius: `${borderRadius}px`
    },
    menuCaption: {
        fontSize: '0.875rem',
        fontWeight: 500,
        color: theme.palette.grey[600],
        padding: '6px',
        textTransform: 'capitalize',
        marginTop: '10px'
    },
    subMenuCaption: {
        fontSize: '0.6875rem',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textTransform: 'capitalize'
    },
    commonAvatar: {
        cursor: 'pointer',
        borderRadius: '8px'
    },
    smallAvatar: {
        width: '22px',
        height: '22px',
        fontSize: '1rem'
    },
    mediumAvatar: {
        width: '34px',
        height: '34px',
        fontSize: '1.2rem'
    },
    largeAvatar: {
        width: '44px',
        height: '44px',
        fontSize: '1.5rem'
    }
});

export default Typography;
